export default {
  loading: false,
  categories: [],
  categoriesOpen: [],
  subcategoriesOpen: []
}
